import { useNavigate } from "react-router-dom";
import BottomNav from "@/components/BottomNav";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted pb-40">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
      <BottomNav onScanTap={() => navigate("/")} />
    </div>
  );
};

export default NotFound;
